import { Component, input, model } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { MatIcon } from '@angular/material/icon'

@Component({
  selector: 'app-search-field',
  imports: [FormsModule, MatIcon],
  template: `
    <div class='input-group'>
      <span class='input-group-text'>
        <mat-icon fontIcon='search'/>
      </span>
      <input
          type="text"
          class="form-control"
          [placeholder]="placeholder()"
          [(ngModel)]="filterStringModel"
      />
      <button
          type="button"
          class="btn btn-outline-secondary"
          [disabled]="!filterStringModel()"
          (click)="filterStringModel.set('')"
          (blur)="coerce()"
      >
        <mat-icon fontIcon='close'/>
      </button>
    </div>
  `,
  styles: `
    .input-group {
      input {
        margin-top: 0;
        font-size: 16px;
      }
      .btn {
        border-radius: 0 6px 6px 0;
        padding: 5px 3px 0 3px;
      }
    }
  `,
})
export class SearchFieldComponent {
  readonly placeholder = input('')
  readonly filterStringModel = model.required<string>()

  protected coerce() {
    this.filterStringModel.set(this.filterStringModel().trim())
  }
}
